














































import { Vue } from "division-marker";
import {
  Component,
  Prop,
  Watch,
  SaitenState,
  ConstsState,
  DmShareds,
  Modal
} from "saiten-base";
import WtHttp from "@/components/WtHttp";
import DateUtil from "@/shared/DateUtil";

import { mapState } from "vuex";
import { WtState } from "@/shared/WtStore";
const platform = require("platform");

@Component({ components: {}, mixins: [] })
export default class StudentTop extends Vue {
  os_error: string | null = null;
  all_sheet_activities: any[] = [];
  reject_sheet_activities: any[] = [];
  terms: any[] = [];
  // 質問版は月別の絞り込みは無し
  // yms: any[] = [];
  // selected_ym: string = DateUtil.to_yyyymm_hyphen(new Date());

  get wt_state(): WtState {
    return this.$store.state.wt;
  }

  get sheet_activities() {
    // 質問版は月別の絞り込みは無し
    // var start_date = new Date(this.selected_ym);
    // start_date = new Date(start_date.getFullYear(), start_date.getMonth(), 1);
    // var end_date = new Date(
    //   start_date.getFullYear(),
    //   start_date.getMonth() + 1,
    //   start_date.getDate()
    // );
    // return this.all_sheet_activities.filter(
    //   sa =>
    //     start_date <= new Date(sa.created_at) &&
    //     new Date(sa.created_at) < end_date
    // );
    return this.all_sheet_activities
  }

  mounted() {
    // 質問版の場合、ログインID発行時点でパスワードを自分で設定済み
    // if (this.wt_state.user && !this.wt_state.user.password_completed) {
    //   window.location.href = "#/study/password_change";
    //   return;
    // }
    // console.log(platform)
    if (platform.os.family == "iOS") {
      const version = parseInt(platform.os.version);
      if (version < 11)
        this.os_error = `対象外のバージョン[${platform.os.version}]`;
    } else if (platform.os.family == "Android") {
      const version = parseInt(platform.os.version);
      if (version < 6)
        this.os_error = `対象外のバージョン[${platform.os.version}]`;
    } else if (platform.os.family == "OS X") {
      if (platform.name != "Safari") this.os_error = `対象外のブラウザ[${platform.name}]`;
    } else {
      this.os_error = "iOS / Android 以外";
    }

    this.load_sheet_activities();
  }
  // enter の初めにインデックス×100でディレイを付ける
  beforeEnter(el: any) {
    el.style.transitionDelay = 20 * el.dataset.index + "ms";
  }
  // enter が終わるか中止されたらディレイを消す
  afterEnter(el: any) {
    el.style.transitionDelay = "";
  }

  async load_sheet_activities() {
    const res = await WtHttp.get("./api/study/sheet_activities");
    const data = res.data;
    this.all_sheet_activities = data.sheet_activities;
    this.reject_sheet_activities = this.all_sheet_activities.filter(
      (sa: any) => sa.saiten_state == "image_reject"
    );
    this.terms = data.terms;

    // 質問版は月別の絞り込みは無し
    //送信履歴の年月リスト
    // const now_ym = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    // const oldest_date =
    //   this.all_sheet_activities.length > 0
    //     ? new Date(
    //         this.all_sheet_activities[
    //           this.all_sheet_activities.length - 1
    //         ].created_at
    //       )
    //     : new Date();
    // const oldest_ym = new Date(
    //   oldest_date.getFullYear(),
    //   oldest_date.getMonth(),
    //   1
    // );
    // this.yms.push(now_ym);
    // do {
    //   const ym = new Date(this.yms[this.yms.length - 1]);
    //   ym.setMonth(ym.getMonth() - 1);
    //   if (ym >= oldest_ym) {
    //     this.yms.push(ym);
    //   } else {
    //     break;
    //   }
    // } while (true);
    // this.selected_ym = DateUtil.to_yyyymm_hyphen(this.yms[0]);
  }

  to_yyyymmdd_hhmmss_slash(date: any) {
    return DateUtil.to_yyyymmdd_hhmmss_slash(date);
  }
  to_yyyymm_hyphen(date: any) {
    return DateUtil.to_yyyymm_hyphen(date);
  }
  to_yyyym_ja(date: any) {
    return DateUtil.to_yyyym_ja(date);
  }
  to_yyyymmdd_slash(date: any) {
    return DateUtil.to_yyyymmdd_slash(date);
  }
}
